import { InjectionToken } from '@angular/core';

import { AppleProfilePresetTypeConfig } from './apple-profile-preset.types';

/**
 * Injection token for providing profile preset type configurations.
 * Use this token to register profile types in your module.
 *
 * @example
 * ```typescript
 * @NgModule({
 *   providers: [
 *     {
 *       provide: APPLE_PROFILE_PRESET_CONFIGS,
 *       useFactory: (
 *         airplayService: AppleAirPlaySecurityProfilePresetsService,
 *         restrictionsService: AppleRestrictionsProfilePresetsService,
 *         wifiService: AppleWifiProfilePresetsService
 *       ) => [
 *         {
 *           profileType: 'airplay-security',
 *           apiService: createApiServiceAdapter(airplayService, ...),
 *         },
 *         // ... more configs
 *       ],
 *       deps: [...],
 *     },
 *   ],
 * })
 * ```
 */
export const APPLE_PROFILE_PRESET_CONFIGS = new InjectionToken<AppleProfilePresetTypeConfig[]>(
  'Apple Profile Preset Configurations'
);
